import { ChangeDetectorRef, Component, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators, FormControl, FormArray } from '@angular/forms';
import { EntityService } from '../../entity.service';
import * as moment from 'moment';
import { FuseAlertType } from '@fuse/components/alert';
import { Router } from '@angular/router';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
@Component({
    selector: 'add-timing',
    templateUrl: './add-timing.component.html',
  styleUrls: ['./add-timing.component.scss']
})
export class AddTimingComponent implements OnInit {
//   dialogRef: any;
//   timings; shwErr = false;showDta = true;showEdt = false;editInputData;
  @Input() editInput;
  @Output() timeEditOutEvnt = new EventEmitter<any>();

  timingEditForm: FormGroup;
  editFormDta: FormArray;
  showAlert: boolean = false;
  //   hldy_in;
    alert: { type: FuseAlertType; message: string } = {
        type: 'success',
        message: ''
    };
    editSec = false;
    addSec = false;closeOtptDta;
    public checked: boolean = false;

  constructor(private _entityService: EntityService,private _formBuilder :FormBuilder,private _changeDetectorRef: ChangeDetectorRef,private route: Router,) { 
    
  }

  ngOnInit(): void {
    console.log('Ramyaaaaaaaaaaaaaa', this.editInput);
    if(this.editInput.formData){
        if(this.editInput.formData[0].twtfr_hrs_in == 1){
            this.checked = true;
        }
    }
    
    this.timingEditForm = this._formBuilder.group({
        editFormDta: this._formBuilder.array([])
    })
    if(this.editInput){
      this.editFacility(this.editInput);
    }
    
  }
  strt_tm;scnd_strt_tm;scnd_end_tm;end_tm;
  editFacility(data) {
    // console.log('Input Dataaaaaaaaaaaaaaaaaaaaaaaaa', data.formData);
    this.editSec = true;
    let control = <FormArray>this.timingEditForm.controls.editFormDta;
    data.formData.forEach(t => {
        // console.log('11111111111111111111111', t);
        if(t.first_session == null){ this.strt_tm = null; this.end_tm = null; } else{this.strt_tm = moment(t.strt_tm, ["h:mm A"]).format("HH:mm");this.end_tm = moment(t.end_tm, ["h:mm A"]).format("HH:mm"); }
       if(t.second_session == null){this.scnd_strt_tm = null; this.scnd_end_tm = null;} else{this.scnd_strt_tm = moment(t.scnd_strt_tm, ["h:mm A"]).format("HH:mm"); this.scnd_end_tm = moment(t.scnd_end_tm, ["h:mm A"]).format("HH:mm"); }

       if(t.hldy_in == 0){ 
           if(this.strt_tm == null){
            this.strt_tm = [{value:t.strt_tm,disabled: false}];
            this.end_tm = [{value:t.end_tm,disabled: false}];
           }else{
            this.strt_tm = [{value:moment(t.strt_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
            this.end_tm = [{value:moment(t.end_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
           }
           if(this.scnd_strt_tm == null){
            this.scnd_strt_tm = [{value:t.scnd_strt_tm,disabled: false}];
            this.scnd_end_tm = [{value:t.scnd_end_tm,disabled: false}];
           }else{
            this.scnd_strt_tm = [{value:moment(t.scnd_strt_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
            this.scnd_end_tm = [{value:moment(t.scnd_end_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
           }
        }
        if(t.hldy_in == 1){
            if(this.strt_tm == null){
                this.strt_tm = [{value:t.strt_tm,disabled: true}];
                this.end_tm = [{value:t.end_tm,disabled: true}];
               }else{
                this.strt_tm = [{value:moment(t.strt_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
                this.end_tm = [{value:moment(t.end_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
               }
               if(this.scnd_strt_tm == null){
                this.scnd_strt_tm = [{value:t.scnd_strt_tm,disabled: true}];
                this.scnd_end_tm = [{value:t.scnd_end_tm,disabled: true}];
               }else{
                this.scnd_strt_tm = [{value:moment(t.scnd_strt_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
                this.scnd_end_tm = [{value:moment(t.scnd_end_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
               }
        }
        //  // console.log('22222222222222222222222', t);
        
         t['hldy_txt'] = false;
         if(t.hldy_in){
             if(t.hldy_in == 0){
                t.hldy_txt = false
             }else{t.hldy_txt = true}
         }

         // console.log(t);
        //  if(t.hldy_in == 0){
        //      // console.log('in 0', t.hldy_in);
        //     this.hldy_in = false;
        //  } else{
        //     // console.log('in 1', t.hldy_in);

        //     this.hldy_in = true;
        //  }
          control.push(this._formBuilder.group({
            enty_ky: data.enty_ky,
            wk_dy_id: t.wk_dy_id,
            wk_dy_nm: t.wk_dy_nm,
            strt_tm: this.strt_tm,
            end_tm: this.end_tm,
            scnd_strt_tm: this.scnd_strt_tm,
            scnd_end_tm: this.scnd_end_tm,
            hldy_in: t.hldy_txt,
          }))
      })
    
    // // console.log(control);
    this.timingEditForm.value.editFormDta = control.value;
    // console.log(this.timingEditForm.value.editFormDta);

}
chngdAry;
updateHoliday(i,r) {
    console.log(i,r);
    console.log(this.timingEditForm.value.editFormDta);
    if(this.timingEditForm.value.editFormDta){
        for(i=0; i<this.timingEditForm.value.editFormDta.length; i++){
            // console.log(this.timingEditForm.value.editFormDta[i].wk_dy_id , r.controls.wk_dy_id.value);
            if((this.timingEditForm.value.editFormDta[i].wk_dy_id == r.controls.wk_dy_id.value) &&this.timingEditForm.value.editFormDta[i].hldy_in == 1){
                this.timingEditForm.value.editFormDta[i].hldy_in = 1
            } else if(this.timingEditForm.value.editFormDta[i].hldy_in == 1){
                this.timingEditForm.value.editFormDta[i].hldy_in = 1
            }else{
                this.timingEditForm.value.editFormDta[i].hldy_in = 0
            }

            if(r.value.wk_dy_id == this.timingEditForm.value.editFormDta[i].wk_dy_id){
                if(r.value.hldy_in == 0){
                    console.log('innnnnnnnnnnnnnnnnn');
                    if(this.strt_tm == null){
                        this.strt_tm = [{value:this.timingEditForm.value.editFormDta[i].strt_tm,disabled: false}];
                        this.end_tm = [{value:this.timingEditForm.value.editFormDta[i].end_tm,disabled: false}];
                        console.log('this.strt_tm', this.strt_tm);
                       }else{
                        this.strt_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].strt_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
                        this.end_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].end_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
                        console.log('this.strt_tm', this.strt_tm);
                       }
                       if(this.scnd_strt_tm == null){
                        this.scnd_strt_tm = [{value:this.timingEditForm.value.editFormDta[i].scnd_strt_tm,disabled: false}];
                        this.scnd_end_tm = [{value:this.timingEditForm.value.editFormDta[i].scnd_end_tm,disabled: false}];
                       }else{
       
                        this.scnd_strt_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].scnd_strt_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
                        this.scnd_end_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].scnd_end_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
                       }
                }
            }

            // if(this.timingEditForm.value.editFormDta[i].hldy_in == 0){ 
            //     if(this.strt_tm == null){
            //      this.strt_tm = [{value:this.timingEditForm.value.editFormDta[i].strt_tm,disabled: false}];
            //      this.end_tm = [{value:this.timingEditForm.value.editFormDta[i].end_tm,disabled: false}];
            //     }else{
            //      this.strt_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].strt_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
            //      this.end_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].end_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
            //     }
            //     if(this.scnd_strt_tm == null){
            //      this.scnd_strt_tm = [{value:this.timingEditForm.value.editFormDta[i].scnd_strt_tm,disabled: false}];
            //      this.scnd_end_tm = [{value:this.timingEditForm.value.editFormDta[i].scnd_end_tm,disabled: false}];
            //     }else{

            //      this.scnd_strt_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].scnd_strt_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
            //      this.scnd_end_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].scnd_end_tm, ["h:mm A"]).format("HH:mm"),disabled: false}];
            //     }
            //  }
            //  console.log(this.timingEditForm.value.editFormDta);
            //  if(this.timingEditForm.value.editFormDta[i].hldy_in == 1){
            //     console.log(this.timingEditForm.value.editFormDta[i].wk_dy_id,'11111111111111111111111');

            //      if(this.strt_tm == null){
            //          this.strt_tm = [{value:this.timingEditForm.value.editFormDta[i].strt_tm,disabled: true}];
            //          this.end_tm = [{value:this.timingEditForm.value.editFormDta[i].end_tm,disabled: true}];
            //         }else{
            //          this.strt_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].strt_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
            //          this.end_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].end_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
            //         }
            //         if(this.scnd_strt_tm == null){
            //          this.scnd_strt_tm = [{value:this.timingEditForm.value.editFormDta[i].scnd_strt_tm,disabled: true}];
            //          this.scnd_end_tm = [{value:this.timingEditForm.value.editFormDta[i].scnd_end_tm,disabled: true}];
            //         }else{
            //          this.scnd_strt_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].scnd_strt_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
            //          this.scnd_end_tm = [{value:moment(this.timingEditForm.value.editFormDta[i].scnd_end_tm, ["h:mm A"]).format("HH:mm"),disabled: true}];
            //         }
            //  }
        }
    // console.log(this.timingEditForm.value.editFormDta);
        this.chngdAry = this.timingEditForm.value.editFormDta;
        // console.log(this.chngdAry);
    }
    // const controls = this.timingEditForm.get("options")["controls"];
    // controls.forEach(control => {
    //   control.get("hldy_in").setValue(false);
    // });
    // controls[i].get("hldy_in").setValue(true);
  }

editFormDtls = [];arry = [];edtPostData = [];a_in;
sendEdt(){
    // this.timingEditForm.value.editFormDta = this.chngdAry;
    console.log('1111111111',this.timingEditForm.value);
    this.showAlert = false;
    
    this.editFormDtls = this.timingEditForm.value.editFormDta;

    console.log(this.editFormDtls);
    console.log('222222222222222',this.editFormDtls);


    if(this.editFormDtls){
        for(let i = 0; i<this.editFormDtls.length; i++){
            
            if (this.editFormDtls[i].strt_tm) {
                this.editFormDtls[i].strt_tm = moment(this.editFormDtls[i].strt_tm, ["h:mm A"]).format("HH:mm");
            }
            if (this.editFormDtls[i].end_tm) {
                this.editFormDtls[i].end_tm = moment(this.editFormDtls[i].end_tm, ["h:mm A"]).format("HH:mm");
            }
            if (this.editFormDtls[i].scnd_strt_tm) {
                this.editFormDtls[i].scnd_strt_tm = moment(this.editFormDtls[i].scnd_strt_tm, ["h:mm A"]).format("HH:mm");
            }
            if (this.editFormDtls[i].scnd_end_tm) {
                this.editFormDtls[i].scnd_end_tm = moment(this.editFormDtls[i].scnd_end_tm, ["h:mm A"]).format("HH:mm");
            }
            if(this.editFormDtls[i].hldy_in == 1){
                this.a_in = 2
            }else{
                this.a_in = 1
            }

            this.edtPostData.push({
                wk_dy_id: this.editFormDtls[i].wk_dy_id,
                strt_tm: this.editFormDtls[i].strt_tm,
                end_tm: this.editFormDtls[i].end_tm,
                scnd_strt_tm: this.editFormDtls[i].scnd_strt_tm,
                scnd_end_tm: this.editFormDtls[i].scnd_end_tm,
                enty_ky: this.editFormDtls[i].enty_ky,
                hndlr_nm: 'facility',
                a_in: this.a_in
            })
        }
        console.log('-------------------------------------------------------------',this.edtPostData);

        for(let i=0; i<this.edtPostData.length; i++){
            if(this.edtPostData[i].strt_tm){
                if (this.edtPostData[i].end_tm <= this.edtPostData[i].strt_tm) {
                    this.alert = {
                        type: 'error',
                        message: 'Please check, End Time should greater than Start Time'
                    }
                    this.showAlert = true;
                }
            }
           
            if (this.edtPostData[i].scnd_end_tm != null && this.edtPostData[i].scnd_strt_tm != null) {
                // // console.log('in')
                if ((this.edtPostData[i].scnd_end_tm && this.edtPostData[i].scnd_strt_tm) <= this.edtPostData[i].strt_tm || (this.edtPostData[i].scnd_end_tm && this.edtPostData[i].scnd_strt_tm) <= this.edtPostData[i].end_tm) {
                    this.alert = {
                        type: 'error',
                        message: 'Please check, Timeperiods between first and second sessions'
                    }
                    this.showAlert = true;
                    return;
                }
            }
    
            if (this.edtPostData[i].scnd_strt_tm) {
                if (this.edtPostData[i].scnd_end_tm <= this.edtPostData[i].scnd_strt_tm) {
                    this.alert = {
                        type: 'error',
                        message: 'Please check, Secondary end Time should greater than Secondary start Time'
                    }
                    this.showAlert = true;
                }
            }
        }

        let finaledtPostDta = this.removeDuplicates(this.edtPostData, 'wk_dy_id');
        console.log(finaledtPostDta);
        this._entityService.post_weeksTmngs(finaledtPostDta).subscribe(res=>{
            console.log(res);
            if(res['status'] == 200){
                this.editSec = false;
                console.log(this.timingEditForm.value.editFormDta);
                this.timeEditOutEvnt.emit(this.timingEditForm.value.editFormDta);
            }
            this._entityService.openSnackBar(res['message'], 'success');
            this.editSec = false;
        })
        
    }

}
tfhrsPostData;
update24hrs(e){
    this.editSec = false;
    console.log('e',e);
    // console.log(this.timingEditForm.value.editFormDta);
    if(e.checked == false){
        this.tfhrsPostData = {
            days: this.timingEditForm.value.editFormDta,
            enty_ky: this.timingEditForm.value.editFormDta[0].enty_ky,
            hndlr_nm: 'facility',
            a_in: 1
        }
    } else{
        this.tfhrsPostData = {
            days: this.timingEditForm.value.editFormDta,
            enty_ky: this.timingEditForm.value.editFormDta[0].enty_ky,
            hndlr_nm: 'facility',
            a_in: 3
        }
    }
    
    console.log(this.tfhrsPostData);
       
    this._entityService.post_twntyFrhrs(this.tfhrsPostData).subscribe(res=>{
        console.log('23Hrs Response',res);
        if(res['status'] == 200){
            this.editSec = false;
            console.log(this.timingEditForm.value.editFormDta);
            this.timeEditOutEvnt.emit(this.timingEditForm.value.editFormDta);
        }
        this._entityService.openSnackBar(res['message'], 'success');
    })
  }
Close() {
    this.editSec = false;
     console.log(this.timingEditForm.value.editFormDta);
    this.timeEditOutEvnt.emit(this.timingEditForm.value.editFormDta);

}
removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject  = {};

    for(var i in originalArray) {
       lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for(i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
     return newArray;
}

onApplyClose(event){
    // console.log("onapplyevent");
    // console.log(event)
  }
}

